import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from '../staleTimes';
import { supportKeys } from '../queryKeys';
import { toList } from '../lib/safe-data';
import { meApi } from './me.api';

export function useSupportMe(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: supportKeys.me(),
    queryFn: () => meApi.permissions(),
    enabled: options.enabled ?? true,
    staleTime: STALE_TIME.slow,
    // Re-gate on tab focus so a mid-session permission change is picked up even if
    // the real-time WS `permission_changed` push was missed (belt-and-suspenders).
    refetchOnWindowFocus: true,
  });
}

/** Tickets awaiting the current user's approval — powers the home widget. */
export function usePendingApprovals() {
  return useQuery({
    queryKey: supportKeys.pendingApprovals(),
    queryFn: () => meApi.pendingApprovals(),
    staleTime: STALE_TIME.fast,
    select: (d) => toList(d, 'me.pendingApprovals'),
  });
}

/**
 * The teams the caller is on. Also the signal for membership-gated UI (the My
 * Teams rail entry/widget) — a non-empty result means "this person is a
 * handler". Cached 60s (membership rarely changes mid-session).
 */
export function useMyTeams() {
  return useQuery({
    queryKey: supportKeys.myTeams(),
    queryFn: () => meApi.teams(),
    staleTime: STALE_TIME.config,
    select: (d) => toList(d, 'me.teams'),
  });
}
